<template>
  <b-modal :active="true">
    <div class="content">
      <b-table
        :data="jobTaskPreogress"
        :loading="isLoading"
        :sticky-header="true"
        :height="500"
        :selected.sync="selected"
      >
        <template slot-scope="props">
          <b-table-column
            field="taskName"
            :label="$t('viewer_3d.select_task_screenshot')"
          >
            {{ props.row.taskName }}
          </b-table-column>
        </template>

        <template #empty>
          <div class="has-text-centered empty-class">
            {{ $t('shared.no_records') }}
          </div>
        </template>
      </b-table>
    </div>
    <footer class="modal-card-foot">
      <b-button @click="close" type="is-danger" :loading="isLoading">
        {{ $t('close') }}
      </b-button>

      <b-button
        type="is-success"
        :disabled="!selected || isLoading"
        :loading="isLoading"
        @click="save"
        >{{ $t('common.save') }}</b-button
      >
    </footer>
  </b-modal>
</template>

<script>
import { GET_JOB_PROGRESS } from '../../../store/jobs/actions/actionTypes';
import { GET_JOB_PROGRESS_TASKS } from '../../../store/jobs/getters/getterTypes';

export default {
  name: 'TasksSelectModal',

  props: {
    loadingProps: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    loadingProps: {
      immediate: true,
      handler(newVal) {
        this.isLoading = newVal;
      },
    },
  },

  computed: {
    currentJob() {
      return this.$store.state.currentJob;
    },

    jobTaskPreogress() {
      return this.$store.getters[GET_JOB_PROGRESS_TASKS];
    },
  },

  data() {
    return {
      isLoading: true,
      tasks: [],
      selected: null,
    };
  },

  async mounted() {
    this.isLoading = true;
    try {
      this.isLoading = true;
      const job = this.currentJob;
      await this.$store.dispatch(GET_JOB_PROGRESS, job._id);
    } catch (error) {
      console.error('Error fetching job progress:', error);
    } finally {
      this.isLoading = false;
    }
  },

  methods: {
    close() {
      this.$emit('close');
    },

    save() {
      this.$emit('save', this.selected._id);
    },
  },
};
</script>

<style scoped>
.content {
  background: white;
  padding: 20px;
  margin-bottom: 0px !important;
}
.modal-card-foot {
  display: flex;
  justify-content: space-between;
}
</style>
